<template>
  <div v-if="list && list.length || (sum_num && show_fake_user)" class="cpt-tooltip-online-info">
    <i
      v-if="!hiddenIcon"
      class="iconfont"
      :class="icon"
      :style="{
        'border-color': show_theme_data?.bar_color ? show_theme_data.bar_color[0] : ''
      }"
    ></i>
    <div
      v-for="(item, index) in show_user_list"
      :key="index"
      class="avatar-list"
      :style="{'z-index': show_user_list.length - index}"
    >
      <div class="img-wrapper" @click="handleEmitClickAvatar($event, item)">
        <i 
          v-if="item.avatar === 'icon'"
          class="iconfont icon-friends flex-center"
          :style="{
            'background': getFakeUserAvatarBg(id, index)
          }"
        ></i>
        <img 
          v-else
          :src="item.avatar" 
          alt="" 
          :style="{
            'border-color': show_theme_data?.imgBorderColor ? show_theme_data.imgBorderColor : 'var(--fill-popover)'
          }"
        >
      </div>
    </div>

    <div 
      v-if="!hiddenNum && real_sum_num > show_num" 
      class="member-number"
      :style="{
        'border-color': show_theme_data?.imgBorderColor ? show_theme_data.imgBorderColor : 'var(--fill-popover)'
      }"
    >
      <div>
        <template v-if="real_sum_num - show_num > 99">
          99
        </template>
        <span>+</span>
        <template v-if="real_sum_num - show_num < 100">
          {{real_sum_num - show_num}}
        </template>
      </div>
    </div>
    
  </div>
</template>

<script>
import { getFakeUserAvatarBg } from '_lib/utils/utils';
export default {
  props: {
    list: {
      default: () => [],
      type: Array,
    },
    sum_num: {
      default: null,
    },
    show_num: {
      default: 5,
      type: Number,
    },
    show_fake_user: {
      default: false,
      type: Boolean,
    },
    icon: {
      default: 'icon-speak-on',
      type: String,
    },
    show_theme_data: {
      default: () => {},
      type: Object,
    },
    hiddenIcon: {
      default: false,
      type: Boolean,
    },
    hiddenNum:{
      default: false,
      type: Boolean,
    },
    id: {
      default: null,
      type: String,
    }
  },
  computed: {
    real_sum_num() {
      if (this.sum_num !== null) {
        return this.sum_num
      } else {
        return this.list.length
      }
    },
    show_user_list() {
      if (!this.show_fake_user) {
        return this.list.slice(0, this.show_num)
      }
      let real_user_list = this.list.slice(0, this.show_num)
      if (real_user_list.length < this.show_num && real_user_list.length < this.sum_num) {
        real_user_list.push(...(new Array(Math.min(this.sum_num - real_user_list.length, this.show_num - real_user_list.length)).fill({
          avatar: 'icon'
        })))
      }
      return real_user_list
    }
  },
  methods: {
    handleEmitClickAvatar(e, item){
      this.$emit('clickAvatar', e, item)
    },
    getFakeUserAvatarBg
  }
}
</script>

<style lang="scss">
.cpt-tooltip-online-info {
  display: flex;
  align-items: center;
  margin-top: 6px;
  flex-shrink: 0;
  > i {
    margin-right: 6px;
    height: 18px;
    width: 18px;
    font-size: 18px;
    color: $d-tx-2;
  }
  .avatar-list {
    flex-shrink: 0;
    margin-right: -4px;
    img {
      height: 28px;
      width: 28px;
      border-radius: 50%;
      border: 2px solid $d-fl-pp;
    }
    i {
      height: 28px;
      width: 28px;
      font-size: 14px;
      border-radius: 50%;
      border: 2px solid $d-fl-pp;
      color: $ct-wh-0;
    }
  }
  .member-number {
    min-width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    border: 2px solid $d-fl-pp;
    padding: 0 4px;
    background: $d-fl-btn;
    div {
      display: flex;
      align-items: center;
      justify-content: center;
      color: $d-tx-1;
      font-family: Roboto;
      font-size: 22px;
      font-weight: 500;
      line-height: 24px;
      zoom: .5;
      span {
        position: relative;
        top: -1px;
      }
    }
  }
}
</style>